import {connect} from 'react-redux';
import {Loader, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import OrderPage from "./OrderPage";
import ZakaznikForm from "../../../forms/ZakaznikForm";
import * as localStorageUtils from "../../../utils/localStorageUtils";
import {withRouter} from "react-router";
import {getVychoziAdresa, redirectToOrderStepNumber} from "../../../utils/utils";
import * as subjektActions from "../../../actions/subjektActions";
import * as opravneniActions from "../../../actions/opravneniActions";
import * as objednavkaActions from "../../../actions/objednavkaActions";
import * as uzivatelActions from "../../../actions/uzivatelActions";
import * as EnumRole from "../../../api/gen/cgo/EnumRole";
import {ORDER_ROUTES, ZAKAZNIK} from "../../../const/routes";
import * as ciselnikActions from "../../../actions/ciselnikActions";
import {withTranslation, WithTranslation} from "react-i18next";

const CURRENT_STEP = 2;

/**
 * Stránka procesu objednávky - Zákazník.
 */
class ZakaznikPage extends Component<WithTranslation> {

    unsavedData = null;

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    componentWillUnmount() {
        const {loggedInUser} = this.props;
        if (this.unsavedData) {
            this.saveData(this.unsavedData);
            this.props.dispatch(objednavkaActions.invalidateDataZakaznik());
            this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        }
    }

    fetchData = () => {
        const {loggedInUser, aktivniSpolecnostId} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            const userId = loggedInUser.data.id;
            this.props.dispatch(objednavkaActions.fetchDataZakazkaIfNeeded(userId));
            this.props.dispatch(objednavkaActions.fetchDataZakaznikIfNeeded(userId));
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(userId));
            this.props.dispatch(subjektActions.fetchUzivatelDetailIfNeeded(userId));
            this.props.dispatch(subjektActions.fetchAktivniAdresyUzivatelIfNeeded(userId, aktivniSpolecnostId.data));
            this.props.dispatch(subjektActions.fetchKartyUzivatelIfNeeded(userId, false));
        }
        if (aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching && aktivniSpolecnostId.data) {
            this.props.dispatch(subjektActions.fetchAktivniSpolecnostDetailIfNeeded(aktivniSpolecnostId.data));
            this.props.dispatch(subjektActions.fetchKartySpolecnostIfNeeded(aktivniSpolecnostId.data, false));
            this.props.dispatch(ciselnikActions.fetchNakladovaStrediskaIfNeeded(aktivniSpolecnostId.data));
        }
    };

    isFetched = () => {
        const {aktivniSpolecnostId, uzivatelDetail, adresyUzivatelList, uzivatelKartyList,
            spolecnostDetail, zakazkaData, zakaznikData, spolecnostKartyList, nakladovaStrediskaList} = this.props;
        return uzivatelDetail.fetched && !uzivatelDetail.isFetching
            && adresyUzivatelList.fetched && !adresyUzivatelList.isFetching
            && uzivatelKartyList.fetched && !uzivatelKartyList.isFetching
            && aktivniSpolecnostId.fetched && !aktivniSpolecnostId.isFetching
            && (aktivniSpolecnostId.data ? spolecnostDetail.fetched && !spolecnostDetail.isFetching && spolecnostKartyList.fetched && !spolecnostKartyList.isFetching && nakladovaStrediskaList.fetched && !nakladovaStrediskaList.isFetching : true)
            && zakazkaData.fetched && !zakazkaData.isFetching
            && zakaznikData.fetched && !zakaznikData.isFetching
    };

    saveData = (data) => {
        const {loggedInUser} = this.props;
        localStorageUtils.saveOrderData(loggedInUser.data.id, CURRENT_STEP, data);
        this.unsavedData = null;
    };

    handleFormChange = (values, _a, _b, oldValues) => {
        const {loggedInUser} = this.props;
        this.unsavedData = values;
        // Pokud se změní vybraný zákazník, vymažeme kompletně data následujících kroků jelikož jsou závislé na zvoleném uživateli
        if (values.uzivatelASpolecnost && oldValues.uzivatelASpolecnost && oldValues.uzivatelASpolecnost !== values.uzivatelASpolecnost) {
            const cisloKroku = ORDER_ROUTES.findIndex(r => r.id === ZAKAZNIK) + 1; // čísla kroků jsou od 1
            for (let i = cisloKroku + 1; i < ORDER_ROUTES.length; i++) {
                localStorageUtils.clearOrderData(loggedInUser.data.id, i);
            }
            const uzivatelId = values.uzivatelASpolecnost.uzivatelId;
            const spolecnostId = values.uzivatelASpolecnost.spolecnostId;
            // Označíme vlastní data jako unfinished a provedeme invalidate, aby nebyl přístupný následující krok bez provedení submitu
            this.saveData({...values, finished: false});
            this.props.dispatch(objednavkaActions.invalidateObjednavkaUzivatel(uzivatelId));
            this.props.dispatch(objednavkaActions.invalidateObjednavkaUzivatelAdresy());
            this.props.dispatch(objednavkaActions.invalidateObjednavkaUzivatelPobocky());
            if (spolecnostId) {
                this.props.dispatch(objednavkaActions.invalidateObjednavkaSpolecnost(spolecnostId));
                this.props.dispatch(objednavkaActions.invalidateObjednavkaSpolecnostAdresy());
            }
            this.props.dispatch(objednavkaActions.invalidateDataZakaznik());
            this.props.dispatch(objednavkaActions.invalidateDataDoprava());
            this.props.dispatch(objednavkaActions.invalidateDataPlatba());
            this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
            this.props.dispatch(objednavkaActions.invalidateObjednavkaLastFinishedStep(loggedInUser.data.id));
        }
    };

    invalidateAndContinue = () => {
        const {loggedInUser} = this.props;
        this.props.dispatch(objednavkaActions.invalidateDataZakaznik());
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastStep(loggedInUser.data.id));
        this.props.dispatch(objednavkaActions.invalidateObjednavkaLastFinishedStep(loggedInUser.data.id));
        this.fetchData();
        redirectToOrderStepNumber(CURRENT_STEP + 1, this.props);
    };

    render() {
        const {loggedInUser, uzivatelKartyList, spolecnostDetail, zakazkaData, zakaznikData,
            adresyUzivatelList, uzivatelDetail, spolecnostKartyList, nakladovaStrediskaList, t} = this.props;

        if (!this.isFetched()) {
            return <Loader/>;
        }

        let initialValues;
        let kartyList;
        const jsemOperator = loggedInUser.data.role === EnumRole.OPERATOR;
        const jsemAdmin = loggedInUser.data.role === EnumRole.ADMIN;
        if (jsemOperator || jsemAdmin) { // pokud jsem operátor nebo admin tak se veškerá data pro tento krok načítají až na základě zvoleného uživatele
            initialValues = {
                ...zakaznikData.data,
            };
        } else { // pokud nejsem operátor, tak všechna data do formuláře se plní dle přihlášeného uživatele
            const maSpolecnost = spolecnostDetail.fetched && !spolecnostDetail.isFetching && spolecnostDetail.data;
            const maKartySpolecnosti = spolecnostKartyList.fetched && !spolecnostKartyList.isFetching && spolecnostKartyList.rows.length > 0;

            const adresa = getVychoziAdresa(adresyUzivatelList.rows);

            // Kombinace karet uživatele a karet společnosti bez přiřazeného uživatele
            // Pokud má uživatel vlastní kartu, má tato přednost
            kartyList = uzivatelKartyList.rows;
            if (maKartySpolecnosti) {
                const spolecnostKarty = spolecnostKartyList.rows.filter(k => !k.uzivatel);
                kartyList = [...kartyList, ...spolecnostKarty];
            }
            const karta = kartyList.length > 0 ? kartyList[0] : null;
            const maNaklStrediska = nakladovaStrediskaList.rows && nakladovaStrediskaList.rows.length > 0;
            const povinneNaklStredisko = maSpolecnost && spolecnostDetail.data.povinneNaklStredisko;
            const naklStrediskoTextem = maSpolecnost && spolecnostDetail.data.naklStrediskoTextem;
            let naklStredObjednavka = null;
            if (povinneNaklStredisko && maNaklStrediska) {
                if (naklStrediskoTextem) {
                    naklStredObjednavka = nakladovaStrediskaList.rows[0].nazevStredisko;
                } else {
                    naklStredObjednavka = nakladovaStrediskaList.rows[0];
                }
            }
            initialValues = {
                naSpolecnost: maSpolecnost,
                nazevSpolecnost: maSpolecnost ? spolecnostDetail.data.nazevSpolecnost : null,
                ic: maSpolecnost ? spolecnostDetail.data.ic : null,
                dic: maSpolecnost ? spolecnostDetail.data.dic : null,
                karta: karta,
                jmenoAPrijmeni: uzivatelDetail.data.zobrazJmeno,
                email: uzivatelDetail.data.email,
                telefon: uzivatelDetail.data.telefon,
                ulice: adresa ? adresa.ulice : null,
                obec: adresa ? adresa.obec : null,
                psc: adresa ? adresa.psc : null,
                notifikaceEmail: uzivatelDetail.data.notifikaceEmail,
                notifikaceSms: uzivatelDetail.data.notifikaceSms,
                naklStredObjednavka: naklStredObjednavka,
                ...zakaznikData.data,
            };

            // Pokud má společnost nastaveno preskocitKontakt, jsou vyplněné povinné položky a v tomto kroku jsme poprvé, můžeme krok přeskočit
            if (maSpolecnost && spolecnostDetail.data.preskocitKontakt && !zakaznikData.data) {
                if (spolecnostDetail.data.nazevSpolecnost && uzivatelDetail.data.jmeno && uzivatelDetail.data.prijmeni) {
                    // console.debug("Přeskakuji krok Zákazník");
                    this.saveData({...initialValues, finished: true});
                    this.invalidateAndContinue();
                }
            }
        }

        return <OrderPage title={t('pages.main.title')} subtitle={t('order.new')} currentStep={CURRENT_STEP}>
            <ZakaznikForm
                onSubmit={data => {
                    return Promise.resolve(this.saveData({...data, finished: true}));
                }}
                onSubmitSuccess={this.invalidateAndContinue}
                onChange={this.handleFormChange}
                initialValues={initialValues}
                kartyList={kartyList}
                zakazkaData={zakazkaData.data}
                isOperator={jsemOperator || jsemAdmin}
                nakladovaStrediskaList={nakladovaStrediskaList.rows}
                spolecnostDetailData={spolecnostDetail.data}
            />
        </OrderPage>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        uzivatelDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_DETAIL_AREA),
        uzivatelKartyList: utils.storeFromArea(state, subjektActions.UZIVATEL_KARTY_LIST_AREA),
        adresyUzivatelList: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_ADRESY_LIST_AREA),
        spolecnostDetail: utils.storeFromArea(state, subjektActions.UZIVATEL_AKTIVNI_SPOLECNOST_AREA),
        zakazkaData: utils.storeFromArea(state, objednavkaActions.ZAKAZKA_DETAIL_AREA),
        zakaznikData: utils.storeFromArea(state, objednavkaActions.ZAKAZNIK_DETAIL_AREA),
        aktivniSpolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        spolecnostKartyList: utils.storeFromArea(state, subjektActions.SPOLECNOST_KARTY_LIST_AREA),
        nakladovaStrediskaList: utils.storeFromArea(state, ciselnikActions.NAKLADOVA_STREDISKA_LIST_AREA),
    }
}

export default withRouter(connect(mapStateToProps)(withTranslation()(ZakaznikPage)));
